import { Component, OnInit, inject } from '@angular/core';
import {
  BrowserMessagesService,
  TableColumn,
  TableComponent,
  SideMenuHeadlineComponent, LoaderComponent
} from '@rbb/ng-web-template-lib';
import { FormService } from '../../services/form.service';
import { Router } from '@angular/router';
import { FormListItem } from '../../data/form-list-item';

@Component({
  selector: 'app-data-protection-officer',
  templateUrl: './data-protection-officer.component.html',
  styleUrls: ['./data-protection-officer.component.css'],
  imports: [TableComponent, SideMenuHeadlineComponent, LoaderComponent]
})
export class DataProtectionOfficerComponent implements OnInit {
  private browserMessagesService = inject(BrowserMessagesService);
  private formService = inject(FormService);
  private router = inject(Router);

  forms: FormListItem[] | undefined;

  columns: TableColumn[] = [
    { name: 'Kategorie', field: 'groupName', type: 'string' },
    { name: 'Name', field: 'name', type: 'string' },
    { name: 'Verantwortliche/r', field: 'createdByLastName', type: 'string' },
    { name: '', field: 'approvalDataProtectionOfficer', type: 'string' }
  ];

  ngOnInit(): void {
    this.getForms();
  }

  getForms(): void {
    this.formService.getFormsForDataProtectionOfficer().subscribe({
      next: (next) => {
        this.forms = next;
      },
      error: (error) => {
        this.browserMessagesService.showHttpError(error, 'Formulare konnten nicht geladen werden');
      }
    });
  }

  openForm(form: FormListItem): void {
    this.router.navigateByUrl('/data-protection-officer/' + form.id).then();
  }
}
